import React, {useEffect, useState} from "react";
import"./DisplayImage.scss"
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Loading from "./Loading";
const DisplayImage = (props)=>{
    const {imageData, description, title, secData, link} = props
    const [intense, setIntense] = useState(0)
    const[secIntense, setSecIntense] = useState(0)
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        const timeId = setTimeout(() => {
            setLoading(true)
        }, 3000)
        return () => {
            clearTimeout(timeId)
        }
    },[loading])
    return(
        <>
            { !loading ? <Loading/> :
                <div className={'displayContainer'}>
                    <div className={'holdImage'}>
                        <div className={'title'}>
                            <a href={link}> {title}</a>
                        </div>
                        <img src={imageData} alt=""
                             onClick={(e) => {
                                 setIntense(intense + 1)
                             }}
                             className={intense % 2 === 0 ? 'imgOne' : 'imgOneBig'}
                        />
                        <img className={secIntense % 2 === 0 ? 'imgTwo' : 'imgTwoBig'} src={secData} alt=""
                             onClick={(e) => {
                                 setSecIntense(secIntense + 1)
                             }}
                        />
                    </div>

                    <div className={'imageDescription'}>
                        {description}
                    </div>

                    <div className={'arrow'}>
                        <ArrowBackIcon className={'insideArrow'} sx={{fontSize: 78}}
                                       onClick={(e) => {
                                           props.setClick(false)
                                       }}
                        />
                    </div>

                </div>
            }
        </>
    )

}

export default DisplayImage
